module.exports = __webpack_public_path__ + "static/background-19df7e40502026999f2b12b501ca92a8.jpg";